/* eslint-disable prettier/prettier */
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import BankService from '../../Services/BankService';
import LoadingBar from '../LoadingBar/LoadingBar';
import AuthService from '../../Services/AuthService';

const gT = (t, key) => t(`component-authorize-enable-banking${key}`);

export default function AuthorizeEnableBanking() {
  const { t } = useTranslation('app');
  const history = useHistory();
  const { search } = useLocation();
  const [loadingText, setLoadingText] = useState('');

  useEffect(() => {
    const updateClientSession = async () => {
      setLoadingText(gT(t, '.loading-bar.authenticating'));
      // Values from address
      let usp = new URLSearchParams(search);
      const code = usp.get('code');
      const state = usp.get('state');
      const error = usp.get('error');
      const errorDescription = usp.get('error_description');

      const stateParams = await AuthService.decode(state);
      usp = new URLSearchParams(stateParams);
      const clientId = usp.get('clientId');
      const externalStateId = usp.get('ext');

      let url = '';
      if (error === null) {
        setLoadingText(gT(t, '.loading-bar.fetching-data'));
        await BankService.authorizeSession(clientId, code, externalStateId);
        url = `/authorization?action=auth&ext=${externalStateId}`;
        history.push(url);
        return;
      }
      url = `/authorization?action=auth&ext=${externalStateId}&error_type=bank&error_description=${errorDescription}`;
      await AuthService.updateOnboardingEvent(
        externalStateId,
        2,
        errorDescription
      );
      history.push(url);
    };
    updateClientSession();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [history, search]);

  return <LoadingBar active status={loadingText} />;
}
